export const allNote = [
  "C0",
  "D0",
  "E0",
  "F0",
  "G0",
  "A0",
  "B0",
  "C1",
  "D1",
  "E1",
  "F1",
  "G1",
  "A1",
  "B1",
  "C2",
  "D2",
  "E2",
  "F2",
  "G2",
  "A2",
  "B2",
  "C3",
  "D3",
  "E3",
  "F3",
  "G3",
  "A3",
  "B3",
  "C4",
  "D4",
  "E4",
  "F4",
  "G4",
  "A4",
  "B4",
  "C5",
  "D5",
  "E5",
  "F5",
  "G5",
  "A5",
  "B5",
  "C6",
  "D6",
  "E6",
  "F6",
  "G6",
  "A6",
  "B6",
  "C7",
  "D7",
  "E7",
  "F7",
  "G7",
  "A7",
  "B7",
  "C8",
  "D8",
  "E8",
  "F8",
  "G8",
  "A8",
  "B8",
  "C9",
  "D9",
  "E9",
  "F9",
  "G9",
];

export const orderNote = ["C", "D", "E", "F", "G", "A", "B"];

export const note = [
  "C0",
  "C1",
  "C2",
  "C3",
  "C4",
  "C5",
  "C6",
  "C7",
  "C8",
  "C9",
];

export const keyboard = [
  { natural: "C0", flat: "q", sharp: "w" },
  { natural: "D0", flat: "w", sharp: "e" },
  { natural: "E0", flat: "e", sharp: "r" },
  { natural: "F0", flat: "r", sharp: "t" },
  { natural: "G0", flat: "t", sharp: "y" },
  { natural: "A0", flat: "y", sharp: "u" },
  { natural: "B0", flat: "u", sharp: "i" },
  { natural: "C1", flat: "i", sharp: "o" },
  { natural: "D1", flat: "o", sharp: "p" },
  { natural: "E1", flat: "p", sharp: "[" },
  { natural: "F1", flat: "[", sharp: "]" },
  { natural: "G1", flat: "q", sharp: "w" },
  { natural: "A1", flat: "w", sharp: "e" },
  { natural: "B1", flat: "e", sharp: "r" },
  { natural: "C2", flat: "r", sharp: "t" },
  { natural: "D2", flat: "t", sharp: "y" },
  { natural: "E2", flat: "y", sharp: "u" },
  { natural: "F2", flat: "u", sharp: "i" },
  { natural: "G2", flat: "i", sharp: "o" },
  { natural: "A2", flat: "o", sharp: "p" },
  { natural: "B2", flat: "p", sharp: "[" },
  { natural: "C3", flat: "[", sharp: "]" },
  { natural: "D3", flat: "q", sharp: "w" },
  { natural: "E3", flat: "w", sharp: "e" },
  { natural: "F3", flat: "e", sharp: "r" },
  { natural: "G3", flat: "r", sharp: "t" },
  { natural: "A3", flat: "t", sharp: "y" },
  { natural: "B3", flat: "y", sharp: "u" },
  { natural: "C4", flat: "u", sharp: "i" },
  { natural: "D4", flat: "i", sharp: "o" },
  { natural: "E4", flat: "o", sharp: "p" },
  { natural: "F4", flat: "p", sharp: "[" },
  { natural: "G4", flat: "[", sharp: "]" },
  { natural: "A4", flat: "q", sharp: "w" },
  { natural: "B4", flat: "w", sharp: "e" },
  { natural: "C5", flat: "e", sharp: "r" },
  { natural: "D5", flat: "r", sharp: "t" },
  { natural: "E5", flat: "t", sharp: "y" },
  { natural: "F5", flat: "y", sharp: "u" },
  { natural: "G5", flat: "u", sharp: "i" },
  { natural: "A5", flat: "i", sharp: "o" },
  { natural: "B5", flat: "o", sharp: "p" },
  { natural: "C6", flat: "p", sharp: "[" },
  { natural: "D6", flat: "[", sharp: "]" },
  { natural: "E6", flat: "q", sharp: "w" },
  { natural: "F6", flat: "w", sharp: "e" },
  { natural: "G6", flat: "e", sharp: "r" },
  { natural: "A6", flat: "r", sharp: "t" },
  { natural: "B6", flat: "t", sharp: "y" },
  { natural: "C7", flat: "y", sharp: "u" },
  { natural: "D7", flat: "u", sharp: "i" },
  { natural: "E7", flat: "i", sharp: "o" },
  { natural: "F7", flat: "o", sharp: "p" },
  { natural: "G7", flat: "p", sharp: "[" },
  { natural: "A7", flat: "[", sharp: "]" },
  { natural: "B7", flat: "q", sharp: "w" },
  { natural: "C8", flat: "w", sharp: "e" },
  { natural: "D8", flat: "e", sharp: "r" },
  { natural: "E8", flat: "r", sharp: "t" },
  { natural: "F8", flat: "t", sharp: "y" },
  { natural: "G8", flat: "y", sharp: "u" },
  { natural: "A8", flat: "u", sharp: "i" },
  { natural: "B8", flat: "i", sharp: "o" },
  { natural: "C9", flat: "o", sharp: "p" },
  { natural: "D9", flat: "p", sharp: "[" },
  { natural: "E9", flat: "[", sharp: "]" },
  { natural: "F9", flat: "q", sharp: "w" },
  { natural: "G9", flat: "w", sharp: "e" },
];
export const keyboardV2 = [
  { natural: "C2", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "C3", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "C4", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "C5", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "C6", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
  { natural: "", flat: "", sharp: "" },
];

export const midiToNote = {
  21: "A",
  22: "A#",
  23: "B",
  24: "C",
  25: "C#",
  26: "D",
  27: "D#",
  28: "E",
  29: "F",
  30: "F#",
  31: "G",
  32: "G#",
  33: "A",
  34: "A#",
  35: "B",
  36: "C",
  37: "C#",
  38: "D",
  39: "D#",
  40: "E",
  41: "F",
  42: "F#",
  43: "G",
  44: "G#",
  45: "A",
  46: "A#",
  47: "B",
  48: "C",
  49: "C#",
  50: "D",
  51: "D#",
  52: "E",
  53: "F",
  54: "F#",
  55: "G",
  56: "G#",
  57: "A",
  58: "A#",
  59: "B",
  60: "C",
  61: "C#",
  62: "D",
  63: "D#",
  64: "E",
  65: "F",
  66: "F#",
  67: "G",
  68: "G#",
  69: "A",
  70: "A#",
  71: "B",
  72: "C",
  73: "C#",
  74: "D",
  75: "D#",
  76: "E",
  77: "F",
  78: "F#",
  79: "G",
  80: "G#",
  81: "A",
  82: "A#",
  83: "B",
  84: "C",
  85: "C#",
  86: "D",
  87: "D#",
  88: "E",
  89: "F",
  90: "F#",
  91: "G",
  92: "G#",
  93: "A",
  94: "A#",
  95: "B",
  96: "C",
  97: "C#",
  98: "D",
  99: "D#",
  100: "E",
  101: "F",
  102: "F#",
  103: "G",
  104: "G#",
  105: "A",
  106: "A#",
  107: "B",
  108: "C",
};
